import PropTypes from 'prop-types'

import Imagen from '../../imagen/Imagen'
import MedioDePago from '../../publicaciones/MedioDePago'
import styles from './Publicacion.module.css'

const Publicacion = ({ publicacion, onClick }) => {
  const simbolo = publicacion.monedaSimbolo ?? publicacion.monSimb ?? ''
  const codigo = publicacion.monCod ?? ''
  const precio = publicacion.precioUnitario ?? publicacion.precio ?? 0

  return (
    <div className={`row item fila ${publicacion.clase ?? ''}`}>
      <div
        className="row container"
        onClick={() => onClick(publicacion.idPublicacion, publicacion.idVendedor)}
      >
        <div
          className={`col-4 ${styles.contenedorImgPublicacion ?? 'contenedor-img-publicacion'}`}
        >
          <Imagen
            className={styles.imgPublicacion}
            width="100%"
            height="100%"
            idPublicacion={publicacion.idPublicacion}
          />
        </div>

        <div className="col">
          <div className="row">
            <div className="col-12">
              <p>{publicacion.titulo}</p>
            </div>

            <div className="col-12">
              <div className="row">
                <div className="col pago-publicacion">
                  <p className="nowrap">
                    {simbolo} {codigo}
                    {precio.toLocaleString('es-AR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </p>
                </div>

                <div className="col pago-publicacion">
                  <p className="icon-publicacion-medio-pago">
                    <MedioDePago mediosPago={publicacion.mediosPago} />
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 mt-auto mb-auto">
              <div className="row">
                <div className="col mr-2">
                  <span className="badge badge-usado badgePublicaciones mr-2">
                    {publicacion.nuevo ? 'Nuevo' : 'Usado'}
                  </span>

                  {publicacion.scrap && (
                    <span className="badge badge-nuevo badgePublicaciones mr-1">
                      <i className="fa fa-recycle" aria-hidden="true" /> Scrap
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Publicacion.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    clase: PropTypes.string,
    titulo: PropTypes.string.isRequired,
    monedaSimbolo: PropTypes.string,
    monSimb: PropTypes.string,
    monCod: PropTypes.string,
    precioUnitario: PropTypes.number,
    precio: PropTypes.number,
    mediosPago: PropTypes.array.isRequired,
    nuevo: PropTypes.bool.isRequired,
    scrap: PropTypes.bool,
    idVendedor: PropTypes.number
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

export default Publicacion
